<template>
    <div class="dashboard-wapper" v-if="statusLoading === 'exist_data'">

        <div class="dashboard">
            <vue-loading :loading="isLoading"></vue-loading>
            <!-- <h3 class="m-b-24">{{ $t('dashboard.name') }}</h3> -->

            <!-- <div class="dashboard__new m-b-40">
                <div class="top_cta">
                    <a href="/swift-expert" class="a-btn a-btn-primary" style="">VIEW OUR SERVICE</a>
                </div>
                
                <h4 class="m-b-24">{{ $t('dashboard.new.name') }}</h4> 
                
                <div class="dashboard__new-content">
                    <div class="dashboard__new-body">
                        <div class="dashboard__new-left">
                            <strong>{{ $t('dashboard.new.new_1') }}</strong>
                            <span>{{ $t('dashboard.new.new_2') }}</span>
                            <p>{{ $t('dashboard.new.new_3') }}</p>
                            <a-button @click="$router.push({name: $routerName.SWIFT_EXPERT})" type="secondary">
                                {{ $t('dashboard.new.btn') }}
                            </a-button>
                        </div>
                        <div class="dashboard__new-middle">
                            <h3>{{ $t('dashboard.new.new_offer_title') }}</h3>
                            <ul>
                                <li>
                                    <i class="fas fa-check-circle"></i>
                                    <p>{{ $t('dashboard.new.new_offer_1') }}</p>
                                </li>
                                <li>
                                    <i class="fas fa-check-circle"></i>
                                    <p>{{ $t('dashboard.new.new_offer_2') }}</p>
                                </li>
                                <li>
                                    <i class="fas fa-check-circle"></i>
                                    <p>{{ $t('dashboard.new.new_offer_3') }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Quick Actions -->
            <!-- <div class="dashboard__quick-actions">
                <h4 class="m-b-24">{{ $t('dashboard.quick_actions.name') }}</h4>
                <div class="dashboard__actions-wapper">
                    //Banner Perceived
                    //Show khi user nhấn/run optimize
                    <box-try-perceived-speed v-model="speedBoxVisible" class="m-r-36"></box-try-perceived-speed>

                    //Banner Actual
                    //phải bật Simple/Smart Preloading hoặc bật Loading Screen thì banner mới xuất hiện. 
                    <box-upgrade v-model="actualBoxVisible" class="m-r-36"></box-upgrade>
                    <template v-for="(box, index) in quickBoxs" >
                        <quick-action-box v-if="box.isVisible" :class="[ index !== quickBoxs.length - 1 ? 'box-margin-right' : '']" :key="index"
                            :box="box"
                            @open-modal-optimize="openModalOptimize"
                        ></quick-action-box>
                    </template>
                </div>
            </div> -->

            <!-- Store Evaluation -->
            <!-- <iframe-store-summary></iframe-store-summary> -->
            <store-evaluation></store-evaluation>

            <div class="dashboard__blogs m-t-40">
                <h4 class="m-b-24">{{ $t('dashboard.blogs.name') }}</h4>
                <div class="dashboard__actions-wapper">
                    <template v-for="(box, index) in blogs" >
                        <blog-box :class="[ ((index + 1) % 3 != 0) ? 'box-margin-right' : '']" :key="index"
                            :box="box"
                        ></blog-box>
                    </template>
                </div>
            </div>

            <vue-modal-optimize-methods
                v-model="modalOptimizeMethods"
                :showBanner="optimizeBanner"
                @doOptimize="doOptimize"
            >
            </vue-modal-optimize-methods>
            <modal-image-limit v-model="imageLimitVisible"
                :isOptimizeTheme="optimizeSettings.optimize_theme"
                @on-optimize-theme="optimizeThemeOnly"
                @buy-more-images="buyMoreImages"
            >
            </modal-image-limit>
            <vue-modal-buy-more-images v-if="imagePlans"
                v-model="buyMoreImageVisible"
                :optimizeSettings="optimizeSettings"
            >
            </vue-modal-buy-more-images>
            <vue-modal-subscribe-image v-model="subscribeImageVisible" @buy-more-images="buyMoreImageVisible = true"></vue-modal-subscribe-image>
            <vue-modal-sucess v-model="modalPurchaseSuccess" :closable="true">
                <template v-if="continuteOptimize" slot="action">
                    <a-button class="m-t-16 m-r-8" type="secondary" @click="modalPurchaseSuccess.isVisible = false">Later</a-button>
                    <a-button type="primary" @click="doOptimize(optimizeSettings)">Continute to optimize</a-button>
                </template>
            </vue-modal-sucess>
            <vue-modal-upgrade-success v-model="modalUpgradeSucess"
                @open-optimize-methods="openModalOptimize"
                @open-modal-actual-speed="openModalActualIntro"
            >
            </vue-modal-upgrade-success>
            <modal-optimize-actual v-model="modalOptimizeActual" @let-start-optimize="openModalOptimize(true)"></modal-optimize-actual>
            <vue-modal-optimization-result v-model="modalOptimizeResultVisible"></vue-modal-optimization-result>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { types as typesAuth } from "@/modules/auth/constant"
import { types as typesDashboard } from './../constant'
import { types as typesPreloading } from '@/modules/preloading/constant'
import { types as typesLoading } from '@/modules/loading_screen/constant'
import { types as typesOptimize } from '@/modules/optimize_image/constant'
import { types as typesCharge } from '@/modules/charge/constant'
import { quickBoxs } from "./../constant"
import { blogs } from './../constant'
import ModalImageLimit from '@/modules/optimize_image/components/ModalImageLimit'
import QuickActionBox from './../components/QuickActionBox'
import BlogBox from './../components/BlogBox'
import BoxTryPerceivedSpeed from './../components/BoxTryPerceivedSpeed'
import BoxUpgrade from './../components/BoxUpgrade'
import ModalOptimizeActual from './../components/ModalOptimizeActual'
import StoreEvaluation from "./../components/StoreEvaluation";
// import IframeStoreSummary from "./../components/IframeStoreSummary";


import isEmpty from "lodash/isEmpty"
import cookie from 'js-cookie'
export default {
    name: 'Home',
    metaInfo: {
        title: 'Home',
    },
    components: {
        ModalOptimizeActual,
        QuickActionBox,
        ModalImageLimit,
        BoxTryPerceivedSpeed,
        BoxUpgrade,
        BlogBox,
        StoreEvaluation,
        // IframeStoreSummary
    },
    data() {
        return {
            imageLimitVisible: false,
            buyMoreImageVisible: false,
            statusLoading: 'first_time',
            isLoading: false,
            quickBoxs: quickBoxs,
            blogs: blogs,
            continuteOptimize: false,
            optimizeBox: quickBoxs.find(box => box.type === 'optimize'),
            preloadingBox: quickBoxs.find(box => box.type === 'preloading'),
            loadingBox: quickBoxs.find(box => box.type === 'loading_screen'),
            swiftExpert: quickBoxs.find(box => box.type === 'swift_expert'),
            speedBoxVisible: false,
            actualBoxVisible: false,
            modalOptimizeActual: false,
            optimizeBanner: false,
            viewOptimizeResult: false,
            modalOptimizeResultVisible: false,
            subscribeImageVisible: false,
            modalPurchaseSuccess: {
                isVisible: false,
                title: this.$t('app.modal.purchase_sucessfully')
            },
            optimizeSettings: {
                optimize_image: false,
                optimize_theme: false,
                settings: []
            },
            modalOptimizeMethods: {
                isVisible: false,
                formSettings: {
                    optimize_image: true,
                    optimize_theme: true,
                    settings: []
                }
            },
            modalUpgradeSucess: {
                isVisible: false,
                endTrial: false,
                type: ''
            },
            isStartPerceived: localStorage.getItem('isStartPerceived'),
            isActiveActual: false,
        }
    },
    computed: {
        ...mapGetters({
            store: typesAuth.getters.GET_STORE,
            preloadingSettings: typesPreloading.getters.GET_SETTINGS,
            loadingSettings: typesLoading.getters.GET_ALL_SETTINGS,
            settingsTheme: typesOptimize.getters.GET_SETTINGS_THEME,
            newOptimize: typesOptimize.getters.GET_NEW_OPTIMIZE,
            imagePlans: typesCharge.getters.GET_IMAGE_PLANS,
            autoSettings: typesOptimize.getters.GET_AUTO_SETTINGS,
            actualOptimizing : 'getActualOptimizing',
            appPusher: typesAuth.getters.GET_APP_PUSHER,
        }),

        isActivePerceived() {
            if (this.preloadingSettings !== null && this.loadingSettings !== null) {
                let isActivePreloading = this.preloadingSettings.active_preload == 1
                let isActiveLoading = this.loadingSettings.settings !== null ? this.loadingSettings.settings.active == 1 : false
                return isActivePreloading || isActiveLoading;
            } else {
                return false;
            }
        }
    },
    watch:{
        store: {
            handler() {
                this.speedBoxVisible = this.store.plan_info.name === 'actual' && this.isActiveActual
                this.actualBoxVisible = this.store.plan_info.name === 'perceived' && this.isActivePerceived
                this.featchOptimize()
                this.featchPreloading()
                 this.featchSwiftExpert()
                this.featchLoadingScreen()
            },
            deep: true
        },
        newOptimize: {
            handler() {
                this.featchOptimize()
            },
            deep: true
        },
        actualOptimizing: {
            handler(val) {
                this.featchOptimize()
                if (val) {
                    this.isActiveActual = true
                    cookie.set('show-perceived-banner', true, { expires: 30 })
                }
            },
            deep: true
        },
        autoSettings: {
            handler() {
                this.featchOptimize()
            },
            deep: true
        },
    },
    async created() {
        this.featchData()
        if (this.actualOptimizing) {
            cookie.set('show-perceived-banner', true, { expires: 30 })
        }
        this.isActiveActual = cookie.get('show-perceived-banner') ? true : false
        this.initPusher()
    },
    methods: {
        ...mapActions({
            getStore: typesAuth.actions.GET_STORE,
            getPreloadingSettings: typesPreloading.actions.GET_SETTINGS,
            getLoadingSettings: typesLoading.actions.GET_ALL_SETTINGS,
            getSettingsTheme: typesOptimize.actions.GET_SETTINGS_THEME,
            optimize: typesOptimize.actions.OPTIMIZE,
            startOptimize: typesOptimize.actions.START_OPTIMIZE,
            getProcess: typesOptimize.actions.GET_PROCESS,
            initPusher: typesAuth.actions.INIT_PUSHER,
        }),

        async featchData() {
            this.isLoading = true
            if ( !this.preloadingSettings ) {
                await this.getPreloadingSettings()
            }
            if ( !this.loadingSettings ) {
                await this.getLoadingSettings()
            }
            this.checkUpgradePlan()
            this.checkFromBuyWord()
            this.featchOptimize()
            this.featchPreloading()
            this.featchSwiftExpert()
            this.featchLoadingScreen()
            this.speedBoxVisible = this.store.plan_info.name === 'actual' && (this.isActiveActual || this.actualOptimizing)
            this.actualBoxVisible = this.store.plan_info.name === 'perceived' && this.isActivePerceived
            this.statusLoading = 'exist_data'
            this.isLoading = false
        },
        setQuery(query) {
            this.pushRouterLinkDefault({
                name: this.$routerName.DASHBOARD,
                query: query,
            });
        },
        featchOptimize() {
            if ( this.autoSettings && this.store && this.newOptimize ) {
                // this.optimizeBox.new = this.store.have_optimized ? false : true
                this.optimizeBox.imageFound = this.newOptimize.image && this.newOptimize.image.total > this.maximumImageInApp && !this.autoSettings.optimize_image ? this.newOptimize.image.total : 0
                this.optimizeBox.fileFound = this.newOptimize.theme && this.newOptimize.theme.total > this.maximumThemeInApp && !this.autoSettings.optimize_theme ? this.newOptimize.theme.total : 0
                this.optimizeBox.status = this.actualOptimizing ? 'optimizing' : ( this.optimizeBox.imageFound > 0 || this.optimizeBox.fileFound > 0 ? 'optimize' : 'optimized')
                this.optimizeBox.isVisible = this.store.plan_info.optimize_images && this.store.plan_info.optimize_theme
            }
        },
        featchPreloading() {
            if ( this.preloadingSettings && this.store ) {
                this.preloadingBox.status = this.preloadingSettings.active_preload ? 'active' : 'inactive'
                // this.preloadingBox.new = isEmpty(this.preloadingSettings)
                this.preloadingBox.isVisible = this.store.plan_info.preloading
            }
        },
        featchSwiftExpert() {
            if (this.store ) {
                this.swiftExpert.status = this.store.expert_onboarding_required ? 'new' : 'view'
            }
        },
        featchLoadingScreen() {
            if ( this.loadingSettings && this.store ) {
                this.loadingBox.status = this.loadingSettings.settings && this.loadingSettings.settings.active ? 'active' : 'inactive'
                // this.loadingBox.new = !this.loadingSettings.style && !this.loadingSettings.settings
                this.loadingBox.isVisible = this.store.plan_info.loading_screen
            }
        },
        buyMoreImages() {
            if (this.store && this.store.trial_end && new Date(this.store.trial_end) > new Date()) {
                this.subscribeImageVisible = true
            } else {
                this.buyMoreImageVisible = true
            }
        },
        checkFromBuyWord() {
            let query = this.$route.query
            this.continuteOptimize = cookie.get('optimize_settings') ? true : false
            if ( !isEmpty(query) && query.hasOwnProperty('image_plan_name')) {
                this.modalPurchaseSuccess.isVisible = true
                this.modalPurchaseSuccess.description = this.$t('app.modal.purchase_sucess_description', {num: query.image_plan_name})
                this.setQuery({})
            }
            if ( this.continuteOptimize ) {
                this.optimizeSettings = JSON.parse(cookie.get('optimize_settings'))
                cookie.remove('optimize_settings')
            }
        },
        // trialSucess() {
        //     this.modalUpgradeSucess.type = 'perceived'
        //     this.speedBoxVisible = false
        //     this.modalUpgradeSucess.isVisible = true
        // },
        checkUpgradePlan() {
            // this.store.pricing_version = 1.1
            let query = this.$route.query
            let oldPlan = Number(this.store.pricing_version) > 1 && Number(this.store.pricing_version) < 2 && !cookie.get('hide-modal-plan-notification')
            if ( (!isEmpty(query) && query.hasOwnProperty('plan')) || oldPlan ) {
                this.modalUpgradeSucess.type = oldPlan ? 'old-plan' : query.plan
                this.modalUpgradeSucess.endTrial = query.hasOwnProperty('end_trial') && query.end_trial == 1 ? true : false
                this.modalUpgradeSucess.isVisible = true
                this.setQuery({})
            }
        },
        optimizeThemeOnly() {
            this.optimizeSettings.optimize_image = false
            this.doOptimize()
        },
        async doOptimize(formSettings=null) {
            let self = this
            this.isLoading = true
            this.modalPurchaseSuccess.isVisible = false
            this.isActiveActual = true
            this.optimizeSettings = formSettings ? this.$clone(formSettings) : this.optimizeSettings
            if ( this.optimizeSettings.optimize_image ) {
                if ( this.store && Number(this.store.buymore_images_available + this.store.default_images_available) === 0 ) {
                    this.imageLimitVisible = true
                    this.isLoading = false
                    return false
                }
            }
            await this.optimize(this.optimizeSettings).then(async res => {
                let { image =  null, theme = null } = res.data
                if ( ( image && image.status) ||  ( theme && theme.status ) ) {
                    cookie.set('actual_optimize_settings', self.optimizeSettings, {expires: 1} )
                    self.getProcess()
                    self.modalOptimizeResultVisible = self.viewOptimizeResult
                    self.viewOptimizeResult = false
                    if ( !self.store.have_optimized ) {
                        await self.startOptimize()
                        self.getStore()
                    }
                }
                if ( image && !image.status ) {
                    if ( image.message == 404 ) {
                        self.toastSuccess({
                            title: self.$t('optimize_image.errors.all_image_optimized'),
                            message: self.$t('optimize_image.errors.no_images_found'),
                            duration: 4
                        })
                    } else {
                        self.toastError({
                            title: "Error",
                            message: self.$t('app.errors.something_went_wrong'),
                            duration: 4
                        })
                    }
                }
                if ( theme && !theme.status ) {
                    if ( theme.message == 404 ) {
                        self.toastSuccess({
                            title: self.$t('optimize_image.errors.all_theme_optimized'),
                            message: self.$t('optimize_image.errors.no_codes_found'),
                            duration: 4
                        })
                    } else {
                        self.toastError({
                            title: "Error",
                            message: self.$t('app.errors.something_went_wrong'),
                            duration: 4
                        })
                    }
                }
                self.isLoading = false
            }).catch(e => {
                self.isLoading = false
                console.log(e);
            })
        },
        async openModalOptimize(showOptimizeBanner=false) {
            this.optimizeBanner = showOptimizeBanner
            if ( !this.settingsTheme ) {
                await this.getSettingsTheme()
            }
            for (var key in this.settingsTheme) {
                if (this.settingsTheme[key] == 1 && key !== 'id') {
                    this.modalOptimizeMethods.formSettings.settings.push(key)
                }
            }
            this.modalOptimizeMethods.isVisible = true
        },
        openModalActualIntro() {
            this.viewOptimizeResult = true
            this.modalOptimizeActual = true
        }
    }
}
</script>

<style lang="scss">
    .top_cta{
      display:flex;
      height:251px;
      width:100%;
      background:url(./../assets/SWE-banner-03.png) no-repeat;
      background-size:contain;
      background-position:center;
    }
    .top_cta a {
      font-size:1.2rem;
      height:43px;;
      align-self:center;
      flex:0 0 18%;
      background-color:white;
      color:black;
      margin:140px 0 0 60px;
      padding-top:5px;
    }
    .dashboard-wapper {
        .dashboard {
            .box-margin-right {
                // margin-right: 32px;
            }
            .blog-wrap {
                margin-left: 16px;
                margin-right: 16px;
                width: calc(33.333333% - 32px);
            }
            &__actions-wapper {
                display: flex;
                flex-wrap: wrap;
                margin-left: -16px;
                margin-right: -16px;
            }
            @media (max-width: 1440px) {
                .box-margin-right {
                    // margin-right: 24px;
                }
                .blog-wrap {
                    margin-left: 12px;
                    margin-right: 12px;
                    width: calc(33.333333% - 24px);
                }
                &__actions-wapper {
                    margin-left: -12px;
                    margin-right: -12px;
                }
            }
        }
    }
    .dashboard{
        &__new{
            &-body{
                display: flex;
                // background-image: url('./../assets/bg-new.png')
            }
            &-content{
                padding: 20px 40px;
                background-image: url('./../assets/bg-new.png');
                border-radius: 4px;
            }
            &-left{
                margin-right: 46px;
                > strong{
                    color: #FFE600;
                }

                > span{
                    font-size: 50px;
                    font-weight: 600;
                    display: block;
                    color: $white-color;
                }
                > p{
                    color: $white-color;
                    margin-bottom: 24px;
                    font-size: 24px;
                }
            }
            &-middle{
                color: $white-color;
                padding: 20px 32px;
                background:rgb(146 159 254 / 20%);
                box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
                border-radius: 12px;
                h3{
                    margin-bottom: 16px;
                }
                li{
                    display: flex;
                    align-items: center;
                    &:not(:last-child){
                        margin-bottom: 12px;
                    }
                    i{
                        margin-right: 12px;
                        color: #51FF92;
                    }
                    p{
                        margin-bottom: 0;
                    }
                }
            }
        }
    }

</style>
